import { useState } from "react";
import { TrackProperties, TrackType } from "./types";

type ReturnType = {
  tracks: TrackProperties[];
  addNewTrack: (type: TrackType) => void;
  handleRemoveTrack: (id: number) => void;
  handleTrackFinished: (id: number, trackFinished?: boolean) => void;
};

export const useTrackControls = (defaultTrack: TrackProperties): ReturnType => {
  const [tracks, setTracks] = useState<Array<TrackProperties>>([defaultTrack]);

  const addNewTrack = (type: TrackType) => {
    const lastTrackId = tracks.length === 0 ? 0 : tracks[tracks.length - 1].id;
    const newTrack = {
      ...defaultTrack,
      id: lastTrackId + 1,
      name: `Track ${lastTrackId + 1}`,
      type,
    };
    setTracks((prev) => [...prev, newTrack]);
  };

  const handleRemoveTrack = (id: number) => {
    setTracks((prev) => {
      const updated = prev.filter((t) => t.id !== id);
      return updated;
    });
  };

  const handleTrackFinished = (id: number, trackFinished?: boolean) => {
    const trackToBeChanged = tracks.find((t) => t.id === id);
    if (trackToBeChanged && trackToBeChanged.trackFinished !== trackFinished) {
      setTracks((prev) =>
        prev.map((t) =>
          t.id === id ? { ...t, trackFinished: trackFinished } : t
        )
      );
    }
  };

  return {
    tracks,
    addNewTrack,
    handleRemoveTrack,
    handleTrackFinished,
  };
};
